const modalitiesMap = {
	Virtual: 'Todo el país y el mundo.',
	Presencial: 'Solo en el municipio de Chinchiná, Caldas, Colombia.',
	Híbrida: 'Combinación de sesiones virtuales y presenciales.',
	A_Domicilio: 'Disponible en áreas específicas del departamento.',
	SemiPresencial: 'Clases presenciales algunos días y virtuales otros.',
	Grabada: 'Contenido pregrabado disponible en cualquier momento.',
	En_Vivo: 'Sesiones virtuales en tiempo real con interacción.',
	Itinerante: 'Presencial en diferentes municipios o zonas del país.',
} as const

export default modalitiesMap
